'use client';

import { useAppStore } from '@/store/app';
import { translate } from '@/lib/i18n';

const QUALITY_CLASS: Record<string, string> = {
  ok: 'bg-emerald-500/10 text-emerald-500',
  partial: 'bg-amber-500/10 text-amber-500',
  stale: 'bg-orange-500/10 text-orange-500',
  missing: 'bg-red-500/10 text-red-500',
  unsupported: 'bg-gf-border/50 text-gf-muted',
};

/** D01 data-quality badge shown next to every research series track. */
export default function DataQualityBadge({ quality, asOf }: { quality: string; asOf?: number }) {
  const { language } = useAppStore();
  const t = translate(language);
  const key = `q${quality ? quality[0].toUpperCase() + quality.slice(1) : 'Unsupported'}` as
    | 'qOk'
    | 'qPartial'
    | 'qStale'
    | 'qMissing'
    | 'qUnsupported';
  const label = t.research[key] ?? t.research.qUnsupported;
  const asOfValid = typeof asOf === 'number' && Number.isFinite(asOf) && asOf > 0;
  const asOfText = asOfValid ? `${t.research.asOf} ${new Date(asOf).toLocaleString()}` : label;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-1.5 py-px text-[10px] font-semibold leading-4 ${
        QUALITY_CLASS[quality] ?? QUALITY_CLASS.unsupported
      }`}
      title={asOfText}
    >
      <span className="h-1 w-1 rounded-full bg-current" />
      {label}
    </span>
  );
}
